import React, { useState, useEffect } from 'react'
import logo from "../../secondAssets/Images/logo.png"
import { FaTwitter, FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { IoLogoGoogleplus } from "react-icons/io";
import { IoMdMail } from "react-icons/io";
import SubscriptionForm from './SubscriptionForm';

const MainFooter = (props) => {
    const { selectedLanguage } = props
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    return (
        <div className="main">
            <div className='second-design-footer-1-main'>
                <div className='second-design-footer-1'>
                    <div className='footer-logo-section'>
                        <img src={logo} alt="" />
                        <p className='footer-img-section-text'>{selectedLanguage?.footer_txt_regular_dental}</p>
                        <p className='trusted-people-text'>{selectedLanguage?.footer_txt_trusted_by} <b>15,000</b> {selectedLanguage?.footer_txt_people}</p>
                    </div>
                    <div className='footer-logo-section second-design-footer-contact-section'>
                        <h2>{selectedLanguage?.footer_txt_contact} <span>{selectedLanguage?.footer_txt_address}</span></h2>
                        <p className='footer-img-section-text footer-no'>{selectedLanguage?.footer_txt_east_crest}</p>
                        <h2>{selectedLanguage?.footer_txt_call} <span>{selectedLanguage?.footer_txt_us}</span></h2>
                        <p className='footer-img-section-text footer-no'>335-565-2900</p>
                        <div className="social-icons-div second-design-footer-social-icons-div">
                            <button><FaTwitter /></button>
                            <button><FaFacebookF /></button>
                            <button><IoLogoGoogleplus /></button>
                            <button><FaLinkedinIn /></button>
                        </div>
                    </div>
                </div>
                <div className='footer-inp-section'>
                    <h1><span>{selectedLanguage?.footer_txt_newsletter}</span> {selectedLanguage?.footer_txt_subscription}</h1>
                    {/* <div>
                        <input type="email" placeholder={selectedLanguage?.footer_txt_email_id} />
                        <button><IoMdMail /></button>
                    </div> */}
                    <SubscriptionForm {...props}/>
                </div>
            </div>
            <div>
                <div className="second-design-footer-2">
                    <div>
                        <p>{selectedLanguage?.footer_txt_copy_right} {currentYear} <span>{selectedLanguage?.footer_txt_designthemes}</span></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainFooter